import { getRKIRegistrations } from '@debbie/common/dist/customers/helpers.js';
import { Site } from '@debbie/common/dist/index.js';
import { TenantStatus } from '@debbie/common/dist/tenants/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import ArrowRight from '../../Icons/ArrowRight.js';
import Phone from '../../Icons/Phone.js';
import Money from '../../Money.js';
const UserRkiRegistrations = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const tenant = useTenant();
    const rkiRegistrations = tenant?.status === TenantStatus.Demo
        ? getDemoRKIRegistration()
        : getRKIRegistrations(props.user.details);
    if (!(rkiRegistrations && rkiRegistrations.length)) {
        return null;
    }
    if (site === Site.Client) {
        if (!rkiRegistrations) {
            return null;
        }
        return (React.createElement("h2", null,
            "(",
            rkiRegistrations.length,
            ") ",
            lang.debtorInfo.rkiRegis));
    }
    if (!rkiRegistrations) {
        return null;
    }
    return (React.createElement("div", null,
        !props.noHeader && React.createElement("h2", null, lang.debtorInfo.rkiRegis),
        rkiRegistrations.map((registration) => {
            const slettetDato = registration.SlettetDato
                ? moment(registration.SlettetDato, 'DDMMYYYY')
                : null;
            return (React.createElement(RKIRegistration, { key: registration?.Debitor?.attributes?.debitorNr +
                    registration?.AdministratorsRefNr, isDeleted: slettetDato?.isBefore(moment()) },
                React.createElement("h4", null,
                    registration.Kreditor &&
                        registration.Kreditor.Navnedata &&
                        registration.Kreditor &&
                        registration.Kreditor.Navnedata.Navn,
                    ' ',
                    registration.Kreditor && registration.Kreditor.TelefonNr && (React.createElement("small", null,
                        React.createElement(Phone, { style: {
                                margin: '2px 2px -2px',
                            } }),
                        registration.Kreditor.TelefonNr)),
                    registration.Beloeb && (React.createElement("span", null,
                        React.createElement(Money, { amount: parseFloat(`${registration.Beloeb}`.replace(',', '.')) *
                                100 })))),
                registration.Fundament && React.createElement("p", null, registration.Fundament),
                registration.RegistreringBemaerkning && (React.createElement("p", null,
                    lang.debtRegistration.remark,
                    ': ',
                    registration.RegistreringBemaerkning)),
                registration.RegistreringStatus && (React.createElement("p", null,
                    lang.debtRegistration.status,
                    ': ',
                    registration.RegistreringStatus)),
                React.createElement("p", null,
                    lang.debtorInfo.administrator,
                    ":",
                    ' ',
                    registration.Administrator &&
                        registration.Administrator.Navnedata &&
                        registration.Administrator &&
                        registration.Administrator.Navnedata.Navn,
                    ' ',
                    registration.Administrator &&
                        registration.Administrator.TelefonNr && (React.createElement("small", null,
                        React.createElement(Phone, { style: {
                                margin: '2px 2px -2px',
                            } }),
                        registration.Administrator &&
                            registration.Administrator.TelefonNr)),
                    React.createElement("span", { style: {
                            float: 'right',
                        } },
                        registration.VideregivelsesDato &&
                            moment(registration.VideregivelsesDato, 'DDMMYYYY').format(THEME.DATE_FORMAT),
                        ' ',
                        React.createElement(ArrowRight, { style: { margin: '0.2em 0 -0.2em' } }),
                        ' ',
                        slettetDato?.isBefore(moment())
                            ? `${lang.debtorInfo.deleted}`
                            : `${lang.debtorInfo.toBedeleted}`,
                        ' ',
                        slettetDato?.format(THEME.DATE_FORMAT))),
                registration.SletteAarsag && (React.createElement("p", null,
                    lang.debtRegistration.deleteReason,
                    ': ',
                    registration.SletteAarsag.Tekst)),
                React.createElement("div", { style: { clear: 'both' } })));
        })));
};
export default UserRkiRegistrations;
const RKIRegistration = styled.div `
  padding: 10px 0;
  border-bottom: 1px solid darkgrey;
  opacity: ${(props) => (props.isDeleted ? 0.7 : 1)};

  &:last-child {
    border-bottom: none;
  }

  p {
    font-size: 0.7em;
    margin-top: 0.3em;
    opacity: 0.6;
    font-weight: bold;
  }

  h4 {
    span {
      float: right;
    }
  }

  p,
  h4 {
    margin: 0;
  }
`;
const getDemoRKIRegistration = () => [
    {
        Beloeb: '12905,64',
        Debitor: {
            Navnedata: { Navn: 'Testdebitor ApS' },
            attributes: { 'xsi:type': 'FirmaData', debitorNr: '123' },
        },
        Kreditor: {
            Navnedata: { Navn: 'Testkreditor A/S' },
            TelefonNr: '12345678',
            attributes: { 'xsi:type': 'FirmaData' },
            HovedBranche: { Kode: '521000' },
        },
        Fundament: 'Fundament',
        SlettetDato: '19062027',
        Administrator: {
            Navnedata: { Navn: 'Advokatfirmaet Test ApS' },
            TelefonNr: '12345678',
            attributes: { 'xsi:type': 'FirmaData' },
        },
        KreditorsRefNr: 'test',
        VideregivelsesDato: '05102022',
        AdministratorsRefNr: '123456',
    },
    {
        Beloeb: '1200,00',
        Debitor: {
            Navnedata: { Navn: 'Testdebitor ApS' },
            attributes: { 'xsi:type': 'FirmaData', debitorNr: '123' },
        },
        Kreditor: {
            Navnedata: { Navn: 'Testkreditor A/S' },
            TelefonNr: '12345678',
            attributes: { 'xsi:type': 'FirmaData' },
            HovedBranche: { Kode: '521000' },
        },
        Fundament: 'Fundament',
        SlettetDato: '19062027',
        Administrator: {
            Navnedata: { Navn: 'Advokatfirmaet Test ApS' },
            TelefonNr: '12345678',
            attributes: { 'xsi:type': 'FirmaData' },
        },
        KreditorsRefNr: 'test',
        VideregivelsesDato: '05102022',
        AdministratorsRefNr: '123456',
    },
];
//# sourceMappingURL=UserRkiRegistrations.js.map